export default function toast(options) {
    const toaster = maybeCreateToaster(options.tagName);
    const toast = makeToast(toaster, options);
    return toast;
}
function maybeCreateToaster(tagName) {
    let container = null;
    if (tagName === "raul-toast") {
        if (!document.querySelector("raul-toaster")) {
            const toaster = document.createElement("raul-toaster");
            document.body.insertBefore(toaster, document.body.firstChild || null);
        }
        container = document.querySelector("raul-toaster");
    }
    if (tagName === "raul-snackbar") {
        if (!document.querySelector("raul-snackbar-group")) {
            const snackbarGroup = document.createElement("raul-snackbar-group");
            document.body.insertBefore(snackbarGroup, document.body.firstChild || null);
        }
        container = document.querySelector("raul-snackbar-group");
    }
    return container;
}
function makeToast(container, options) {
    const { timeout, avatar, origin, variant, dismissible, heading, body, content, ctaMessage, ctaUrl, ctaCallback, meta, actions, read, severity, } = options;
    if (!container)
        return;
    if (options.tagName === "raul-toast") {
        const toast = document.createElement(options.tagName);
        if (!toast)
            return;
        toast.timeout = timeout;
        toast.avatar = avatar;
        toast.origin = origin;
        toast.heading = heading;
        toast.body = body;
        (toast.meta = meta),
            (toast.read = read),
            (toast.severity = severity),
            (toast.meta = meta);
        toast.actions = actions;
        if (container)
            container.insertBefore(toast, container.firstChild || null);
        return toast;
    }
    else if (options.tagName === "raul-snackbar") {
        const snack = document.createElement(options.tagName);
        snack.timeout = timeout;
        snack.variant = variant;
        snack.dismissible = dismissible;
        snack.heading = heading;
        snack.content = content;
        snack.ctaMessage = ctaMessage;
        snack.ctaUrl = ctaUrl;
        snack.ctaCallback = ctaCallback;
        if (container)
            container.insertBefore(snack, container.firstChild || null);
        return snack;
    }
}
//# sourceMappingURL=toast.js.map
